import type { QueryClient } from '@tanstack/react-query';

/**
 * Invalidate every safety-related query key across both the dashboard
 * (SafetyScreen) and records (SafetyRecordsScreen) key families.
 * Call this in the onSuccess of every safety mutation so both views
 * reflect the change without a manual refresh.
 */
export function invalidateSafety(qc: QueryClient) {
  // Dashboard keys
  qc.invalidateQueries({ queryKey: ['safety-dashboard'] });
  qc.invalidateQueries({ queryKey: ['safety-compliance'] });
  qc.invalidateQueries({ queryKey: ['safety-meetings'] });
  qc.invalidateQueries({ queryKey: ['safety-jsa-list'] });
  // One JSA, as the detail modal and the edit screen read it. Without this an
  // edited or resubmitted JSA reopened on the version cached before the change.
  qc.invalidateQueries({ queryKey: ['safety-jsa-detail'] });
  qc.invalidateQueries({ queryKey: ['safety-incidents'] });
  qc.invalidateQueries({ queryKey: ['safety-near-misses'] });
  qc.invalidateQueries({ queryKey: ['team-cert-summary'] });

  // Records keys (SafetyRecordsScreen uses a separate key family)
  qc.invalidateQueries({ queryKey: ['safety-records-meetings'] });
  qc.invalidateQueries({ queryKey: ['safety-records-jsas'] });
  qc.invalidateQueries({ queryKey: ['safety-records-incidents'] });
  qc.invalidateQueries({ queryKey: ['safety-records-near-misses'] });

  // Compliance training keys
  qc.invalidateQueries({ queryKey: ['safety-training-certifications'] });
  qc.invalidateQueries({ queryKey: ['safety-training-courses'] });
}
